import React from 'react';
import Toggle from "components/Form/Toggle";
import {FormikHelpers} from "formik";
import {RoleFilter as RoleFilterSpec} from "types/AudienceCriteria";
import {useQuery} from "react-query";
import ngage from "services/ngage";
import Checkbox from "../../../Checkbox/Checkbox";
import {toTitleCase} from "services/string";

type Props = {
    formik: FormikHelpers<any>
    groupIndex: number
    filter?: RoleFilterSpec | null
}

function RoleFilter({formik, groupIndex, filter}: Props) {
    const {data: roles, isLoading: isRolesLoading} = useQuery('roles.all', ngage.roles.all)

    const handleToggleFilter = (checked: boolean) => {
        formik.setFieldValue(
            `criteria.groups.${groupIndex}.filters.role`,
          checked? {value: []} : undefined
        )
    }

    return (
        <div className="mt-8">
            <div className="flex">
                <Toggle
                    label={`Has role${!!filter? '' : '...'}`}
                    checked={!!filter}
                    onChange={handleToggleFilter}
                    loading={isRolesLoading}
                    disabled={isRolesLoading}
                />
            </div>

            {!!filter &&
                <div className="w-full pl-14 mt-2 sm:flex flex-wrap gap-x-4 gap-y-2">
                    {!!roles && roles.map(role => (
                        <Checkbox
                            key={role.id}
                            id={`groups.${groupIndex}.roles.${role.id}`}
                            name={`criteria.groups.${groupIndex}.filters.role.value`}
                            value={role.id.toString()}
                            label={toTitleCase(role.name)}
                        />
                    ))}
                </div>
            }
        </div>
    );
}

export default RoleFilter;